import { acceptObjectValue } from '../../field-viewer/shared-normalizers';
export function acceptFullNameValue(args) {
    return acceptObjectValue(args);
}

//# sourceMappingURL=full-name-normalize-value.js.map